if (!navigator.userAgent.match(/Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi|Tablet|iPad/i)) {
  document.querySelectorAll('.header [id^="Details-"] summary').forEach((summary) => {
    summary.addEventListener('mouseenter', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      summary.parentElement.setAttribute('open', 'true');
    });
    summary.addEventListener('mouseleave', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      summary.parentElement.removeAttribute('open');
    });

    const megaMenuContent = summary.parentElement.querySelector('.mega-menu__content');
    if (megaMenuContent) {
      megaMenuContent.addEventListener('mouseenter', () => {
        summary.parentElement.setAttribute('open', 'true');
      });
      megaMenuContent.addEventListener('mouseleave', () => {
        summary.parentElement.removeAttribute('open');
      });
    }
  });
}


/*****************************/
document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll('.wa_thumbnail-list__item .thumbnail');
    if (buttons.length > 0) {
        buttons[buttons.length - 1].click();
    }
});
/***************************/